var map = {
	"./1fca1f72ac91ff736f3ff93ad1cb555f.png": 365,
	"./Logo Vertical.jpg": 366,
	"./Logo Vertical.png": 367,
	"./bg_login.jpg": 368,
	"./bg_login2.jpg": 369,
	"./broadcasters/365Media_Islanda.png": 370,
	"./broadcasters/A1_Bulgaria.png": 371,
	"./broadcasters/Abu_Dhabi_Media_Network.png": 372,
	"./broadcasters/Al_Jazeera.png": 373,
	"./broadcasters/ArenaSport_Pan Balcani.png": 374,
	"./broadcasters/Atv_Turchia.png": 375,
	"./broadcasters/B92_Serbia.png": 376,
	"./broadcasters/BT_logo.png": 377,
	"./broadcasters/BeIn_Sports.png": 378,
	"./broadcasters/Bein-sports.png": 379,
	"./broadcasters/CMore_Svezia.png": 380,
	"./broadcasters/Canal+_PanAfrica.png": 381,
	"./broadcasters/CbcSport_Azerbaijan.png": 382,
	"./broadcasters/Cctv_Cina.png": 383,
	"./broadcasters/CleverMedia_Romania.png": 384,
	"./broadcasters/CytaVision_Cipro.png": 385,
	"./broadcasters/DAZN.png": 386,
	"./broadcasters/DAZN_old.png": 387,
	"./broadcasters/DigitAlb_Albania.png": 388,
	"./broadcasters/Eclat_CoreaSud.gif": 389,
	"./broadcasters/ElevenSports_Belgio.png": 390,
	"./broadcasters/Espn.png": 391,
	"./broadcasters/FijiTv_Fiji.png": 392,
	"./broadcasters/Forthnet_Group.png": 393,
	"./broadcasters/Fox.png": 394,
	"./broadcasters/GazpromMedia_Russia.gif": 395,
	"./broadcasters/Grupo_Bandeirantes.png": 396,
	"./broadcasters/Ho_Chi_Minh_Television.png": 397,
	"./broadcasters/I-Cable_HongKong.png": 398,
	"./broadcasters/Irib_Iran.png": 399,
	"./broadcasters/Kalyon_Turchia.png": 400,
	"./broadcasters/Max_logo.png": 401,
	"./broadcasters/MediaGroup_Ucraina.png": 402,
	"./broadcasters/Mediaset.png": 403,
	"./broadcasters/MncTv_Indonesia.png": 404,
	"./broadcasters/Movistar_Spagna.png": 405,
	"./broadcasters/MultiChoice.png": 406,
	"./broadcasters/O2_RepubblicaCeca.png": 407,
	"./broadcasters/PCCW.png": 408,
	"./broadcasters/Paramount_Pics_logo.png": 409,
	"./broadcasters/Polsat_Polonia.png": 410,
	"./broadcasters/PremierMedia.png": 411,
	"./broadcasters/RTRS_Bosnia_Herzegovina.png": 412,
	"./broadcasters/Rai.png": 413,
	"./broadcasters/Rai_Italia.png": 414,
	"./broadcasters/Rcs+rds.png": 415,
	"./broadcasters/Rcti_Indonesia.png": 416,
	"./broadcasters/Rti_logo.png": 417,
	"./broadcasters/STV.webp": 418,
	"./broadcasters/SetantaEurasia_PanRussia.png": 419,
	"./broadcasters/ShweThanLwin_Birmania.png": 420,
	"./broadcasters/Sky.png": 421,
	"./broadcasters/SkyNet_Birmania.png": 422,
	"./broadcasters/SkyPerfectTv_Giappone.png": 423,
	"./broadcasters/Sky_NuovaZelanda.png": 424,
	"./broadcasters/SonyPictures.png": 425,
	"./broadcasters/Sport.Tv_Portogallo.png": 426,
	"./broadcasters/SportTv_Slovenia.png": 427,
	"./broadcasters/Sportitalia.png": 428,
	"./broadcasters/StarTimes_PanAfrica.png": 429,
	"./broadcasters/Sýn.png": 430,
	"./broadcasters/TNT_Sports.png": 431,
	"./broadcasters/Teleclub_Svizzera.png": 432,
	"./broadcasters/TelekomRomania_Romania.png": 433,
	"./broadcasters/Telekom_Slovenije.png": 434,
	"./broadcasters/Telenet_Belgio.png": 435,
	"./broadcasters/Telesport_Russia.png": 436,
	"./broadcasters/TelewizjaPolska_Polonia.png": 437,
	"./broadcasters/TlnMediaGroup_Canada.jpg": 438,
	"./broadcasters/Tln_Canada.png": 439,
	"./broadcasters/Trt_Turchia.png": 440,
	"./broadcasters/Tsn_Malta.png": 441,
	"./broadcasters/Tv2_Danimarca.png": 442,
	"./broadcasters/Tv2_Norvegia.png": 443,
	"./broadcasters/Tv4Group_Svezia.png": 444,
	"./broadcasters/UnitedMedia_Slovenia.png": 445,
	"./broadcasters/Viacom_logo.png": 446,
	"./broadcasters/Ziggo_PaesiBassi.png": 447,
	"./broadcasters/mediamax_network.jpeg": 448,
	"./broadcasters/pptv.png": 449,
	"./broadcasters/starzplay.png": 450,
	"./broadcasters/tring.svg": 451,
	"./broadcasters/xinjiang_tv_cn.png": 452,
	"./dashboard/trending-down.png": 453,
	"./dashboard/trending-up.png": 454,
	"./layouts/below header.png": 455,
	"./layouts/boxed.png": 456,
	"./layouts/dark horizontal.png": 457,
	"./layouts/default horizontal.png": 458,
	"./layouts/drawer nav.png": 459,
	"./layouts/fixed.png": 460,
	"./layouts/framed.png": 461,
	"./layouts/full width.png": 462,
	"./layouts/inside header horizontal.png": 463,
	"./layouts/mini sidebar.png": 464,
	"./layouts/no header mini sidebar.png": 465,
	"./layouts/simple horizontal inside menu.png": 466,
	"./layouts/top to header.png": 467,
	"./layouts/vertical no header.png": 468,
	"./loader.svg": 169,
	"./logo-white.png": 164,
	"./logo.png": 83,
	"./logo.svg": 469,
	"./logo_login.jpg": 470,
	"./logo_login.png": 471,
	"./logo_login_2022.jpg": 472,
	"./logo_login_old.png": 473,
	"./logo_login_old1.png": 474,
	"./marker.png": 475,
	"./pentagon.png": 476,
	"./pentagon_1.png": 477,
	"./placeholder.jpg": 478,
	"./teams/Alessandria.png": 479,
	"./teams/AltoAdige.png": 480,
	"./teams/Ascoli.png": 481,
	"./teams/Atalanta.png": 482,
	"./teams/Avellino.png": 483,
	"./teams/Bari.png": 484,
	"./teams/Benevento.png": 485,
	"./teams/Bologna.png": 486,
	"./teams/Brescia.png": 487,
	"./teams/Cagliari.png": 488,
	"./teams/Carrarese.png": 489,
	"./teams/Catania.png": 490,
	"./teams/Catanzaro.png": 491,
	"./teams/Cesena.png": 492,
	"./teams/ChievoVerona.png": 493,
	"./teams/Cittadella.png": 494,
	"./teams/Como.png": 495,
	"./teams/Cosenza.png": 496,
	"./teams/Cremonese.png": 497,
	"./teams/Crotone.png": 498,
	"./teams/Empoli.png": 499,
	"./teams/Feralpi.png": 500,
	"./teams/Fiorentina.png": 501,
	"./teams/Foggia.png": 502,
	"./teams/Frosinone.png": 503,
	"./teams/Genoa.png": 504,
	"./teams/Inter.png": 505,
	"./teams/Juventus.png": 506,
	"./teams/JuventusBlack.png": 507,
	"./teams/Lazio.png": 508,
	"./teams/Lecce.png": 509,
	"./teams/Mantova.png": 510,
	"./teams/Milan.png": 511,
	"./teams/Modena.png": 512,
	"./teams/Monza.png": 513,
	"./teams/Napoli.jpg": 514,
	"./teams/Napoli.png": 515,
	"./teams/Novara.png": 516,
	"./teams/Palermo.png": 517,
	"./teams/Parma.png": 518,
	"./teams/Perugia.png": 519,
	"./teams/Pescara.png": 520,
	"./teams/Pisa.png": 521,
	"./teams/Pordenone.png": 522,
	"./teams/Reggina.png": 523,
	"./teams/Roma.png": 524,
	"./teams/SPAL.png": 525,
	"./teams/Salernitana.png": 526,
	"./teams/Sampdoria.png": 527,
	"./teams/Sassuolo.jpg": 528,
	"./teams/Sassuolo.png": 529,
	"./teams/Spezia.png": 530,
	"./teams/Ternana.png": 531,
	"./teams/Torino.png": 532,
	"./teams/Triestina.png": 533,
	"./teams/Udinese.jpg": 534,
	"./teams/Udinese.png": 535,
	"./teams/Venezia.png": 536,
	"./teams/Verona.png": 537,
	"./teams/Vicenza.png": 538,
	"./teams/VirtusEntella.png": 539,
	"./teams/logo_seriea.png": 540,
	"./w-logo.png": 75,
	"./widget/birds.png": 541,
	"./widget/bread.png": 542,
	"./widget/building.png": 543,
	"./widget/disc.png": 544,
	"./widget/flying.png": 545,
	"./widget/glass.png": 546,
	"./widget/noodles.png": 547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 364;